import React, {Component} from 'react'
import '../styles/index.scss'
import OriginalFileManagementPage from './OriginalFileManagementPage'

class OriginalFileManagementPageContainer extends Component {
    render() {
        return (
            <div className='OriginalFileManagementPageContainer'>
                <OriginalFileManagementPage/>
            </div>
        )
    }
}

export default OriginalFileManagementPageContainer
